export const makeTextBold = (value: string, query: string) => {
  const regex = new RegExp(query, 'i')
  return value.replace(regex, (val) => {
    return `<strong>${val}</strong>`
  })
}
